<!-- 添加栏位 -->
<template>
  <el-form ref="form" :model="form" class="addFields">
    <div ref="sortableRef" style="height: 100%">
      <div class="fieldsList" v-for="(items, index) in fieldsArr" :class="{ fieldsListActive: fieldsArrActive[index] }"
        :key="items.id" @click="onActive(index, items.id)" :id="items.id" :ref="items.id">
        <!-- 选择题干 -->
        <div class="fieldsChoice">
          <el-dropdown>
            <span class="el-dropdown-link">
              {{ items.type }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown"> </el-dropdown-menu>
          </el-dropdown>

          <el-select v-model="items.type" placeholder="请选择" @change="selectChange(items)">
            <el-option v-for="item in fieldsOptions" :key="item.id" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
        </div>

        <!-- 输入内容 -->
        <div class="fieldsContent">
          <!-- 输入框 -->
          <div class="fieldsContentSelect">
            <el-input auto-complete="off" type="textarea" :autosize="{
              minRows: textareaRows[items.typeId],
              maxRows: textareaRows[items.typeId] + 14,
            }" class="no-scroll" v-model="items.value" v-if="
              !(items.typeId == 'option' || items.typeId == 'chart' || items.typeId == 'audio' || items.typeId == 'analysis') &&
              items.typeId
            " :style="{
              'font-weight':
                items.typeId == 'firstLevel' || items.typeId == 'secondLevel'
                  ? 600
                  : 500,
            }" placeholder="请输入内容">
            </el-input>
            <quill-edit v-if="items.typeId == 'analysis'" :value="items.value" :arrayIndex="index" @setValue="setValue"></quill-edit>

            <div class="audio_item" v-if="items.typeId == 'audio' && items.hearLink" style="width: 100%">
              <el-upload class="upload-video" :action="uploadAudio" :show-file-list="false"
                :before-upload="beforeUploadAudio" :on-success="handleAudioSuccess" :on-error="handleAudioError" :headers="customHeaders">
                <i class="el-icon-video-play" style="color: #0BAE6A;font-size: 15rem;"></i> &nbsp;&nbsp;{{
                  parseTime(items.hearTime)
                }}&nbsp;&nbsp;{{items.audioName}}
              </el-upload>

            </div>
            <div class="audio_item" v-if="items.typeId == 'audio' && !items.hearLink">
              <el-upload class="upload-video" :action="uploadAudio" :show-file-list="false"
                :before-upload="beforeUploadAudio" :on-success="handleAudioSuccess" :on-error="handleAudioError" :headers="customHeaders">
                <i class="el-icon-upload" style="color: #0BAE6A;font-size: 15rem;"></i> &nbsp;添加音频
              </el-upload>

            </div>

            <!-- 选项 -->
            <Add-Select v-if="items.typeId == 'option'" :id="items.id" @selectListChange="selectListChange"
              :selectListCopy="items.selectList" />

            <!-- 上传图片 -->
            <!-- v-if="items.typeId == 'chart'" -->
            <el-upload class="uploadImg" :action="uploadUrl" accept="image/png, image/jpeg" :on-preview="handlePreview"
              :on-change="handleChange" :on-remove="handleRemove" :file-list="items.fileList" list-type="picture"
              :auto-upload="true" :on-success="uploadSuccess" :on-error="uploadError"
              :class="{ uploadImgBorder: items.fileList.length > 0 }"
              :headers="customHeaders"
              >
              <div class="uploadBtn">
                <img src="../../../assets/images/icon-addImg.png" />
                添加
              </div>
            </el-upload>
          </div>

          <div class="fieldsContentBottom">
            <p class="idText">
              ID:<!--  @input="handleInput" -->
              <el-input v-model="items.fieldId" placeholder="ID" size="mini" maxlength="5" @input="handleInput"
                class="idTextInput"></el-input>
            </p>
            <el-tooltip :content="tooltipContent" placement="bottom" :open-delay="openDelay">
              <img class="copyId" src="../../../assets/images/icon-copy.png" @click="copyTextFn(items.fieldId)" />
            </el-tooltip>
            <div class="queSelect idText idText1">
              编号:
              <el-select v-model="items.que_num" placeholder="请选择" size="mini" @change="queNumBlur">
                <el-option v-for="item in numMap" :key="item.value" :label="item" :value="item">
                </el-option>
              </el-select>
              <!-- <el-input v-model="items.que_num" placeholder="编号" size="mini" class="idTextInput idTextInput1"
                @blur="queNumBlur"></el-input> -->
            </div>
            <div class="queSelect" v-if="items.typeId == 'hearing'">
              题目绑定:
              <el-input style="margin-left: 5rem;" v-model="items.bindNum" placeholder="输入题目ID" size="mini" class=""
                @blur="queNumBlur"></el-input>
            </div>
            <div class="queSelect" v-if="items.typeId == 'chart'">
              题目绑定:
              <el-input style="margin-left: 5rem;" v-model="items.bindNum" placeholder="输入题目ID" size="mini" class=""
                @blur="queNumBlur"></el-input>
            </div>
            <div class="queSelect" v-if="items.typeId == 'subject'">
              <template v-if="items.hasAnswerMethod">
                <div>作答方式:</div>
                <el-tooltip class="item" effect="light" :content="getTypeLable(items.que_type,false)" placement="top-start">
                  <el-select v-model="items.que_type" placeholder="请选择" size="mini">
                    <el-option v-for="item in answerMethodMap" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </template>
              <template v-else>
                <div>题目类型:</div>
                <el-tooltip class="item" effect="light" :content="getTypeLable(items.que_type)" placement="top-start">
                  <el-select v-model="items.que_type" placeholder="请选择" size="mini">
                    <el-option v-for="item in queTypeMap" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </template>
            </div>
          </div>
        </div>

        <!-- 移动题干 -->
        <div class="fieldsMove">
          <img class="fieldsMoveImg" src="../../../assets/images/icon-move.png" alt="" />
        </div>

        <!-- 操作 -->
        <div class="fieldsOperation">
          <div class="handleFields" @click="handleOperate($event)"></div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <el-dialog custom-class="errorDialog" title="保存失败" :visible.sync="errorMsgVisible" width="30%">
      <span>{{ errorMsg }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="errorMsgVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <div class="operateBox" v-if="isOperate" ref="operateBox"
      :style="{ top: screenTop + lastScroll.y - scroll.y + 'px', left: screenLeft + lastScroll.x - scroll.x + 'px' }">
      <OperateFrame :fieldsArr.sync="fieldsArr" :id="nowId" @operateInsertBlank="operateInsertBlank"
        @operateCopy="operateCopy" @scjShow="scjShow" @collectionAdd="collectionAdd"
        @operateInsertCollection="operateInsertCollection" />
    </div>
  </el-form>
</template>



<script>
import AddSelect from "./AddSelect.vue";
import OperateFrame from "./operateFrame.vue";
import { copyText } from "../../../utils/util";
import { fieldsOptions, textareaRows } from "../../../constants/constants";
import { EventBus } from "@/utils/event-bus";
import { getCoilingDetail, modifyCoiling,modifyRefineCoiling } from "@/api/addModule";
import { uploadUrl, uploadFile, uploadAudio } from "@/constants/constants";
import { mapMutations } from "vuex";
import _ from 'lodash';
import { getToken } from '@/utils/auth';
import quillEdit from '../../quillEdit/quillEdit'
import { getModuleType,answerMethodMap,queTypeMap,sleep } from "@/utils/util.js";

let addFieldThis;
let fieldsArrExternal;
const TAG = "[AddFields.vue] ";

const fieldsBasis = {
  id: "1",
  type: "栏位名称",
  typeId: "field",
  value: "", // 栏位输入内容
  fileList: [], // 栏位中图片列表
  fieldId: "1", // 栏位id
  que_num: "", // 编号
  selectList: [], // 选项列表
  score: "", // 分数
  time: "", // 时间
  pyramid: "", // 阶段分数总和
  que_type: "", // 问题类型
  hearLink: "", // 听力材料
  hearTime: "", // 听力时间
  bindNum: "", // 绑定题号
};

/* const queTypeMap = [
  {
    value: 'readWord',
    label: '朗读'
  },
  {
    value: 'readChapter',
    label: '朗读短文'
  },
  {
    value: 'readChapterAfterTape',
    label: '模仿朗读'
  },
  {
    value: 'choiceAfterHearing',
    label: '听后选择'
  },
  {
    value: 'choicePictureAfterSentence',
    label: '听句子选择图片'
  },
  {
    value: 'choiceAnswerAfterSentence',
    label: '听句子选择答案'
  },
  {
    value: 'choiceAnswerAfterDialogue',
    label: '听对话选择答案'
  },
  {
    value: 'choiceDialogueUnderstanding',
    label: '对话理解'
  },
  {
    value: 'choiceEssayUnderstanding',
    label: '短文理解'
  },
  {
    value: 'choiceShortDialogueAnswer',
    label: '听短对话回答问题'
  },
  {
    value: 'choiceLongDialogueAnswer',
    label: '听长对话回答问题'
  },
  {
    value: 'choiceListeningEssayAnswer',
    label: '听短文回答问题'
  },
  {
    value: 'expressionAnswerAfterListening',
    label: '听后回答'
  },
  {
    value: 'expressionShortDialogueAnswer',
    label: '听短对话，回答问题'
  },
  {
    value: 'expressionLongDialogueAnswer',
    label: '听长对话，回答问题'
  },
  {
    value: 'expressionMonologueAnswer',
    label: '听独白回答问题'
  },
  {
    value: 'expressionSelectInformation',
    label: '听选信息'
  },
  {
    value: 'expressionAnswerQuestion',
    label: '回答问题'
  },
  {
    value: 'expressionAskQuestion',
    label: '询问信息'
  },
  {
    value: 'expressionDialogue',
    label: '日常对话'
  },
  {
    value: 'expressionQuestionAnswer',
    label: '情景问答'
  },
  {
    value: 'retellAfterListening',
    label: '听后转述'
  },
  {
    value: 'retellExpressingInformation',
    label: '信息转述'
  },
  {
    value: 'retellOralComposition',
    label: '口头作文'
  },
  {
    value: 'retellTopicOverview',
    label: '话题简述'
  },
  {
    value: 'recordAfterListen',
    label: '听后记录'
  },
  {
    value: 'dialogue',
    label: '情景对话'
  },
  //新增
  {
    value: 'dialogueChoiceImg',
    label: '听对话，选择与对话内容相符的图片'
  },
  {
    value: 'sentenceChoiceAnswer',
    label: '听句子，选择与句子匹配的最佳应答'
  },
  {
    value: 'dialogueChoiceSentence',
    label: '听对话，选择最佳选项完成句子'
  },
  {
    value: 'dialogueChoiceAnswer',
    label: '听对话，根据对话内容及问题，选择最佳选项'
  },
  {
    value: 'essayFillBlanks',
    label: '听短文，完成表中所缺信息，每空仅填一词'
  },
  {
    value: 'shortDgeChoiceImg',
    label: '听短对话，选择图片'
  },
  {
    value: 'shortDgeChoiceAnswer',
    label: '听短对话，选择答案'
  },
  {
    value: 'longDgeChoiceAnswer',
    label: '听长对话，选择答案'
  },
  {
    value: 'essayFillForm',
    label: '听短文，填写表格'
  },
  {
    value: 'wordsToSentence',
    label: '连词成句'
  }
] */

const numMap = ['一', '二', '三', '四', '五', '六', '第一部分', '第二部分', '第三部分', '第四部分', '第五部分', '第六部分', 'A', 'B', 'C', 'D', 'E', 'I', 'II', 'III', 'IV', 'V', 'VI', '第一节', '第二节', '第三节', '第四节', '第五节', '第六节'];
for (let i = 1; i <= 40; i++) {
  numMap.push(i + '');
}
export default {
  name: "AddFields",
  components: {
    AddSelect,
    OperateFrame,
    quillEdit
  },
  props: {
    isOperate: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      customHeaders:{
          'Authorization':getToken()
      },
      idOriginalText: "", // id原来的内容
      screenLeft: 0, // 操作弹框左侧距离
      screenTop: 0, // 操作弹框top侧距离
      queTypeMap: queTypeMap,
      answerMethodMap: answerMethodMap,
      form: {},
      fieldsArrActive: [], // 栏位中状态
      fieldsArr: [], // 栏位列表
      fieldsArrOld: [], // 初始栏位列表
      dialogImageUrl: "", // 图片放大地址
      dialogVisible: false, // 图片放大开关
      nowId: "", // 当前选中栏位id
      coilingId: -1, // 套卷id
      time: parseInt(new Date().getTime()),
      tooltipContent: "复制ID", // 文字提示
      openDelay: 1000, // 文字提示延时时间
      fieldCount: 1, // ID计数器
      scroll: { x: 0, y: 0 },
      lastScroll: { x: 0, y: 0 },
      errorMsgVisible: false,
      errorMsg: "",
      publishState:0,//发布状态 0-未发布 1-已发布 2-修改未发布
    };
  },
  computed:{
    getTypeLable(){
      return function(val,isOld=true){
        let typeMap = isOld?this.queTypeMap:this.answerMethodMap
        let item = typeMap.find(u=>u.value==val)
        return item?item.label:''
      }
    }
  },
  mounted() {
    // 监听点击空白事件
    document.addEventListener("click", this.monitoringClick.bind(this));

    window.addEventListener("scroll", this.handleScroll)

    addFieldThis = this;

    // 新增套卷
    EventBus.$on("addCoilingHandle", this.emptyFieldsArr);

    // 保存套卷-试题内容
    EventBus.$on("saveCoiling", this.saveCoiling);

    EventBus.$on("operateDelete", this.operateDelete);

    // 赋分-保存套卷-试题内容
    EventBus.$on("giveSaveCoiling", this.giveSaveCoiling);

    // 文件导入
    EventBus.$on("txtImportHandle", this.txtImportHandle);
    
    //刷新页面数据 
    EventBus.$on("refreshPageData", this.refreshPageData);
    EventBus.$on("refreshStorage", this.refreshStorage);
    EventBus.$on("insert2paperStorage", this.insert2paperStorage);
    
    
  },

  // 销毁前
  beforeDestroy() {
    document.removeEventListener("click", this.monitoringClick.bind(this));
    window.removeEventListener("scroll", this.handleScroll)
    EventBus.$off("addCoilingHandle", this.emptyFieldsArr);
    EventBus.$off("saveCoiling", this.saveCoiling);
    EventBus.$off("operateDelete", this.operateDelete);
    EventBus.$off("giveSaveCoiling", this.giveSaveCoiling);
    EventBus.$off("txtImportHandle", this.txtImportHandle);
    EventBus.$off("refreshPageData", this.refreshPageData);
    EventBus.$off("refreshStorage", this.refreshStorage);
    EventBus.$off("insert2paperStorage", this.insert2paperStorage);
    this.fieldsJSONChange([]);
  },

  methods: {
    setValue(val,index){  //quillEdit内容赋值给解析模块
      this.fieldsArr[index].value = val;
    },
    handleScroll() {
      this.scroll = {
        x: window.scrollX,
        y: window.scrollY
      }
    },
    scjShow(data) {
      this.$emit('scjShow', data);
    },
    ...mapMutations(["fieldsJSONChange"]),

    collectionAdd(fieldStr) {
      this.$emit('collectionAdd', fieldStr);
    },

    // 文件导入
    txtImportHandle(file, type) {
      let _this = this;

      var formData = new FormData(); // 创建FormData对象
      formData.append("file", file); // 将文件添加到FormData对象中

      var xhr = new XMLHttpRequest(); // 创建XMLHttpRequest对象

      xhr.open("POST", uploadFile, true);
      // 初始化请求，这里的'/upload'是服务器上处理上传文件的路径
      xhr.setRequestHeader('Authorization', getToken());
      xhr.onload = function () {
        if (this.status == 200) {
          console.log("文件上传成功", this);

          if (typeof this.response == "string") {
            const res = JSON.parse(this.response);

            if (res["code"] == 0) {
              _this.$message({
                message: "上传文件成功！",
                type: "success",
              });

              if (!res["data"]) return;

              const data = JSON.parse(res.data);

              if (type == "add") {
                _this.fieldsArr.push(...data);
              } else {
                _this.fieldsArr = data;
              }

              // 这里处理对象变化的逻辑
              fieldsArrExternal = _this.fieldsArr;
              _this.$emit("fieldsArrChange", _this.fieldsArr);
            } else {
              _this.$message.error("上传文件失败！");
            }
          }
        } else {
          console.error("文件上传失败");
          _this.$message.error("上传文件失败！");
        }
      };

      xhr.send(formData); // 发送请求
    },

    // 选项-赋值
    selectListChange(selectList, id) {
      console.log("选项-赋值", selectList, id);

      this.fieldsArr.some((item) => {
        if (item.id == id) {
          item.selectList = selectList;
          return true;
        }
      });
    },

    // 复制栏位
    operateCopy(id) {
      let isOperateDelete = this.fieldsArr.some((item, index) => {
        let itemCopy = JSON.parse(JSON.stringify(item));
        itemCopy.id = parseInt(new Date().getTime()) + "";

        if (item.id == id) {
          this.fieldsArr.splice(index + 1, 0, itemCopy);
          this.changeNowId();
          return true;
        }
      });

      if (isOperateDelete) {
        this.$message({
          message: "复制栏位成功！",
          type: "success",
        });

        // 这里处理对象变化的逻辑
        fieldsArrExternal = this.fieldsArr;
        this.$emit("fieldsArrChange", this.fieldsArr);
      } else {
        this.$message({
          message: "复制栏位失败！",
          type: "error",
        });
      }
    },

    // 插入空白
    operateInsertCollection(direction, id, fields) {
      //eslint-disable
      console.log("开始从收藏夹插入数据:", fields)
      this.time++;
      //let fieldsBasisCopy = { ...fieldsBasis };
      fields.id = this.time + "";
      if(!fields?.hasAnswerMethod&&fields.typeId==='subject'){
        fields.hasAnswerMethod = true;
        const queType = this.queTypeMap.find(item => item.value === fields.que_type);
        if(queType){
          fields.rawQueType = fields.que_type;
          fields.que_type = queType.methodValue;
        }
      }
      let isOperateDelete = false;
      if (id === 0) {
        this.fieldsArr.splice(this.fieldsArr.length, 0, fields);
        this.changeNowId();
        isOperateDelete = true;
      } else {
        isOperateDelete = this.fieldsArr.some((item, index) => {
          if (item.id == id) {
            if (direction) {
              // 向上
              this.fieldsArr.splice(index, 0, fields);
              this.fieldsArrActive = [];
              this.fieldsArrActive[index + 1] = true;
              //this.progressItemIdx = this.progressItemIdx + 1
            } else {
              // 向下
              this.fieldsArr.splice(index + 1, 0, fields);
            }
            this.changeNowId();
            return true;
          }
        });
      }

      if (isOperateDelete) {
        /* this.$message({
          message: "添加栏位成功！",
          type: "success",
        }); */

        // 这里处理对象变化的逻辑
        fieldsArrExternal = this.fieldsArr;
        this.$emit("fieldsArrChange", this.fieldsArr);
      } else {
        this.$message({
          message: "添加栏位失败！",
          type: "error",
        });
      }
      //eslint-disable
    },

    // 插入空白
    operateInsertBlank(direction, id) {
      this.time++;
      let fieldsBasisCopy = { ...fieldsBasis };
      fieldsBasisCopy.id = this.time + "";
      fieldsBasisCopy.fieldId = this.fieldCount + '';
      let isOperateDelete = this.fieldsArr.some((item, index) => {
        if (item.id == id) {
          if (direction) {
            // 向上
            this.fieldsArr.splice(index, 0, fieldsBasisCopy);
            this.fieldsArrActive = [];
            this.fieldsArrActive[index + 1] = true;
          } else {
            // 向下
            this.fieldsArr.splice(index + 1, 0, fieldsBasisCopy);
          }
          this.changeNowId();
          return true;
        }
      });

      if (isOperateDelete) {
        this.$message({
          message: "添加栏位成功！",
          type: "success",
        });

        // 这里处理对象变化的逻辑
        fieldsArrExternal = this.fieldsArr;
        this.$emit("fieldsArrChange", this.fieldsArr);
      } else {
        this.$message({
          message: "添加栏位失败！",
          type: "error",
        });
      }
    },
    debounce(fn, delay) { //防抖
        let timer = null //借助闭包
        return function() {
            if(timer){
                clearTimeout(timer) 
            }
            timer = setTimeout(fn,delay)
        }
    },
    // id输入变化
    handleInput(event) {
      // 只允许数字
      event = event.replace(/\D/g, "");
      // 如果有必要，可以在这里加上其他的过滤条件，例如只允许正整数
      let text = "";
      for (let i = 0; i < event.length; i++) {
        const element = event[i].replace(/\D/g, "");
        console.log(i, element);
        if (element) {
          text += element;
        }
      }
      setTimeout(() => {
        this.fieldsArr.find((x) => x.id == this.nowId)["fieldId"] = text;
      }, 1300);
    },

    // 图片新增
    handleChange(file, fileListArr) {
      console.log(TAG, JSON.stringify(file), "handleChange", fileListArr);

      if (file["status"] != "success") return;

      for (let i = 0; i < fileListArr.length; i++) {
        if (fileListArr[i]["status"] == "success") {
          // if (fileListArr[i].hasOwnProperty("response")) {

          if (
            Object.prototype.hasOwnProperty.call(fileListArr[i], "response")
          ) {
            if (fileListArr[i]["response"]["code"] == 0) {
              fileListArr[i].url = fileListArr[i]["response"]["data"];
            }
          }
        }
      }

      this.fieldsArr.find((x) => x.id == this.nowId)["fileList"] = fileListArr;
      console.log(TAG, this.fieldsArr, "handleChange", fileListArr);
    },

    // 图片移除
    handleRemove(file, fileListArr) {
      console.log(TAG, file, "handleChange", fileListArr);

      setTimeout(() => {
        this.fieldsArr.find((x) => x.id == this.nowId)["fileList"] =
          fileListArr;
      }, 1000);
    },

    // 图片上传成功
    uploadSuccess(response, file) {
      console.log(TAG, "uploadSuccess", response, file);
      if (response["code"] == 0) {
        this.$message({
          message: "图片上传成功！",
          type: "success",
        });
      } else {
        this.$message.error("图片上传失败！");
      }
    },

    // 图片上传失败
    uploadError() {
      console.log(TAG, "uploadError");
      this.$message.error("图片上传失败！");
    },

    // 赋分-保存套卷-试题内容
    giveSaveCoiling(arr) {
      let fieldsArrDeep = JSON.parse(JSON.stringify(this.fieldsArr));
      console.log(TAG, "触发确定questionNumber=", arr);
      console.log(TAG, "触发确定fieldsArrDeep=", fieldsArrDeep);

      let arrFlattening = []; // 扁平化

      const flattening = (list) => {
        for (let i = 0; i < list.length; i++) {
          arrFlattening.push(list[i]);

          if (Object.prototype.hasOwnProperty.call(list[i], "children")) {
            flattening(list[i].children);
          }
        }
      };

      flattening(arr);
      console.log(TAG, "扁平化arrFlattening= ", arrFlattening);

      for (let i = 0; i < fieldsArrDeep.length; i++) {
        for (let ii = 0; ii < arrFlattening.length; ii++) {
          if (fieldsArrDeep[i].id == arrFlattening[ii].divId) {
            fieldsArrDeep[i].pyramid = arrFlattening[ii].pyramid;
            fieldsArrDeep[i].score = arrFlattening[ii].score;
            fieldsArrDeep[i].time = arrFlattening[ii].time;
          }
        }
      }

      console.log(TAG, "触发确定fieldsArrDeep2=", fieldsArrDeep);

      this.fieldsArr = fieldsArrDeep;

      // 保存套卷-试题内容
      this.saveCoiling(true);
    },

    // 保存套卷-试题内容
    saveCoiling(bool) {
      // 调用父组件 - 新增套卷
      console.log('------ 保存套卷-试题内容', this.coilingId);
      if (this.coilingId < 0) return;

      let data = [{ id: this.coilingId, content: JSON.stringify(this.fieldsArr) }];
      console.log(TAG, "saveCoiling data", this.fieldsArr);

      switch(this.$store.state.pageNum){
        case "1":
          modifyCoiling(data)
          .then(async(res) => {
            console.log(TAG, "saveCoiling res", res);
            if (res["code"] == 0) {
              // this.$message({
              //   message: "保存成功！",
              //   type: "success",
              // });
              //保存答题流程
              if(!bool){  //赋分不保存流程
                await sleep(100); 
                EventBus.$emit("saveProgress");
              }else{
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });
              }
              // EventBus.$emit("saveProgress");
              this.fieldsArrOld = JSON.parse(JSON.stringify(this.fieldsArr));
              EventBus.$emit("contentChangeIdEnd", this.coilingId);

              EventBus.$emit("closeDialog");
              
              console.log("🐞 - AddFields.vue:812 - publishState :", this.publishState)
              if(this.publishState==1){
                const coilingId = res["data"][0]
                console.log("🐞 - AddFields.vue:814 - coilingId :", coilingId)
                window.sessionStorage.removeItem(coilingId+'topList');
                window.sessionStorage.removeItem(coilingId+'progress');
                window.sessionStorage.removeItem(coilingId);
              }

              EventBus.$emit("getCoiling");
            } else {
              this.errorMsg = res["info"];
              this.errorMsgVisible = true;
            }
          })
          .catch((e) => {
              this.errorMsg = e;
              this.errorMsgVisible = true;
          });
          break;
        case "2":
          modifyRefineCoiling(data)
          .then(async (res) => {
            console.log(TAG, "saveCoiling res-------", res);
            if (res["code"] == 0) {
              // this.$message({
              //   message: "保存成功！",
              //   type: "success",
              // });
              //保存答题流程
              if(!bool){  //赋分不保存流程
                await sleep(100);
                EventBus.$emit("saveProgress");
              }else{
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });
              }
              // EventBus.$emit("saveProgress");
              this.fieldsArrOld = JSON.parse(JSON.stringify(this.fieldsArr));
              EventBus.$emit("contentChangeIdEnd", this.coilingId);

              EventBus.$emit("closeDialog");
            } else {
              this.errorMsg = res["info"];
              this.errorMsgVisible = true;
            }
          })
          .catch((e) => {
              this.errorMsg = e;
              this.errorMsgVisible = true;
          });
          break;
      }
    },

    // 点击复制文字
    copyTextFn(value) {
      console.log('copyTextFn', value)
      copyText(value);

      this.$message({
        message: "复制成功！",
        type: "success",
      });
    },

    // 点击编辑获取焦点事件
    IDFocus(e) {
      this.idOriginalText = e.target.innerHTML;
    },

    // 点击编辑失去焦点事件
    IDBlur(e) {
      let idText = e.target.innerHTML;
      if (!idText.trim()) {
        e.target.innerHTML = this.idOriginalText;
        return;
      }

      // 调用修改名称接口
    },

    // 题干选择变化
    selectChange(items) {
      console.log(TAG + "题干选择变化", items);

      this.isTextarea = false;

      fieldsOptions.some((item) => {
        if (items.type == item.label) {
          items.typeId = "";

          setTimeout(() => {
            items.typeId = item.name;
          }, 100);
          return true;
        }
      });
console.log('---- ------',this.fieldsArr);
      // 这里处理对象变化的逻辑
      fieldsArrExternal = this.fieldsArr;
      this.$emit("fieldsArrChange", this.fieldsArr);
    },

    // 删除栏位
    operateDelete(id) {
      console.log(123456, id);

      let isOperateDelete = this.fieldsArr.some((item, index) => {
        console.log(789, item.id, id);
        if (item.id == id) {
          // const fieldsArrCopy = JSON.parse(JSON.stringify(this.fieldsArr));
          // fieldsArrCopy.splice(index, 1);

          this.fieldsArr.splice(index, 1);
          return true;
        }
      });

      if (isOperateDelete) {
        this.$message({
          message: "删除栏位成功！",
          type: "success",
        });

        // 这里处理对象变化的逻辑
        fieldsArrExternal = this.fieldsArr;
        this.$emit("fieldsArrChange", this.fieldsArr);

        this.changeNowId();
      } else {
        this.$message.error("删除栏位失败！");
      }
    },

    changeNowId() {
      let index = this.fieldsArrActive.findIndex((x) => x);
      if (this.fieldsArr[index]) {
        this.nowId = this.fieldsArr[index].id;
      } else {
        this.fieldsArrActive = [];
      }
    },

    // 创建栏位
    createField() {
      // 获取接口id
      // let time = parseInt(new Date().getTime() / 1000) + "";
      if (this.coilingId == -1) {
        this.$message.error("请先新增套卷！");
        return;
      }

      this.time++;
      const flag =this.fieldsArr.some(item=>Object.hasOwn(item,'hasAnswerMethod'))
      let fieldsBasisCopy = { ...fieldsBasis };
      if(flag||!this.fieldsArr.length){
        fieldsBasisCopy.hasAnswerMethod = true; // 是否有作答方式
      }
      fieldsBasisCopy.id = this.time + "";
      fieldsBasisCopy.fieldId = this.fieldCount + '';

      this.fieldsArr.push(fieldsBasisCopy);

      // 这里处理对象变化的逻辑
      fieldsArrExternal = this.fieldsArr;
      this.$emit("fieldsArrChange", this.fieldsArr);
    },

    // 编号失焦
    queNumBlur() {
      this.$emit("fieldsArrChange", this.fieldsArr);
    },

    // 点击操作
    handleOperate(e) {
      console.log("高度", window.innerHeight);
      this.lastScroll = _.cloneDeep(this.scroll);
      let wHeight = window.innerHeight;

      this.$emit("update:isOperate", true);
      // this.$parent.isOperate = true;

      console.log("isOperate1", this.isOperate1);

      const rect = e.target.getBoundingClientRect();
      console.log('rect', rect)

      // this.screenLeft = rect.left + window.scrollX - 47;
      this.screenLeft = rect.left - 47;
      // if (rect.top + 150 < wHeight) {
      if (rect.top + 200 < wHeight) {
        console.log("rect.top + 150", rect.top + 150);
        this.screenTop = rect.top + window.scrollY + 26;
      } else {
        this.$nextTick(() => {
          let operateBoxH = this.$refs.operateBox.offsetHeight;
          console.log("operateBoxH", operateBoxH);

          this.screenTop = rect.top - operateBoxH - 6;
        });
      }
    },

    // 栏位聚焦
    onActive(index, id) {
      if (!this.fieldsArrActive[index]) {
        this.fieldsArrActive = [];
        this.fieldsArrActive[index] = true;
        this.nowId = id;
      }
    },

    // 图片放大展示
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    // 监听点击事件
    monitoringClick(e) {
      const target = e.target;
      const classList = target.classList;

      // 转换为字符串输出
      const classes = Array.from(classList).join(" ");

      // console.log(classes == "handleFields");
      if (classes != "handleFields") {
        this.$emit("update:isOperate", false);
      }
    },
    insert2paperStorage(selectedNodes, checkedPaperIdsArr){
        console.log(sessionStorage.getItem(this.$store.state.coilingId+'topList'))
        console.log("开始插入内存数据")
        console.log("selectedNodes.length==",selectedNodes, selectedNodes.length,JSON.parse(selectedNodes[0].progress))
        console.log("checkedPaperIdsArr==", checkedPaperIdsArr)
        console.log("checkedPaperIdsArr.length==", checkedPaperIdsArr.length)
        const fieldsArrChangeFn = () => {
          fieldsArrExternal = this.fieldsArr;
          this.$emit("fieldsArrChange", this.fieldsArr);
        };
        checkedPaperIdsArr.forEach((id) => {
              getCoilingDetail(id)
                .then((res) => {
                  console.log(TAG, "emptyFieldsArr getCoilingDetail res", res);
                  if (res["code"] == 0) {
                      let key = id + "";
                      
                    let content = res["data"]["content"]
                      ? res["data"]["content"]
                      : "[]";
                      console.log('content==', content)
                    let contentJSON = JSON.parse(content);
                    console.log('contentJSON', contentJSON)
                    console.log('contentJSON', contentJSON.length)
                    
                    let storageContent = sessionStorage.getItem(key);
                    if (storageContent) {
                        console.log('storageContent', storageContent.length)
                    }
                    
                    let newContent = []
                    //如果内存中有，那么读内存加
                    console.log('storageContent', storageContent)
                    if (storageContent) {                    
                        let storageContentJSON = JSON.parse(storageContent)
                        console.log('storageContentJSON。length', storageContentJSON.length)
                        if (storageContentJSON) {
                            newContent.push(...storageContentJSON)
                        }
                        
                    } else {//如果没有，则读数据库加
                        if (contentJSON.length > 0) {
                            newContent.push(...contentJSON)
                        }             
                    }
                    selectedNodes.forEach((node) => {
                        let collectionType = node.collectionType
                        console.log('collectionType==', collectionType)
                        let nodeContent = JSON.parse(node.content)
                        console.log('nodeContent before reset id', nodeContent)
                        this.resetId(nodeContent)
                        console.log('nodeContent after reset id', nodeContent)
                        if ("test_single" === collectionType) {
                            newContent.push(nodeContent);
                        }
                        else if ("test_all" === collectionType) {
                            newContent.push(...nodeContent);
                        }
                    })
                    console.log('newContent33333', newContent)
                    sessionStorage.setItem(key, JSON.stringify(newContent));
                    
                    console.log("id=========", id)
                    console.log("this.coilingId=========", this.$store.state.coilingId)
                    if (id === this.$store.state.coilingId) {
                        this.fieldsArr = newContent;
                        fieldsArrChangeFn();
                        EventBus.$emit("contentChangeIdUn", this.$store.state.coilingId);
                        this.$emit("update:enable", res["data"]["status"] == "0");
                    }
                    
                    //以下为塞流程
                    
                    let progress = res["data"]["top_list"]
                      ? res["data"]["top_list"]
                      : "[]";
                      console.log('progress==',res, progress)
                    let progressJSON = JSON.parse(progress);
                    let storageProgress = sessionStorage.getItem(key+'topList');

                    if(storageProgress==''||storageProgress==null||storageProgress==undefined||storageProgress=='[]'){
                      storageProgress = sessionStorage.getItem(key+'progress');
                      // storageProgress='';
                      if(storageProgress==''||storageProgress==null||storageProgress==undefined||storageProgress=='[]'){
                        storageProgress='';
                      }
                    }

                    console.log(key+'topList',storageProgress);
                    let newProgress = []
                    if (storageProgress) {
                        
                        
                        let storageProgressJSON = JSON.parse(storageProgress)
                        if (storageProgressJSON) {
                            storageProgressJSON = storageProgressJSON.filter((item)=> item.coilingId === id);
                            
                            //sessionStorage.setItem(key+'topList', JSON.stringify(storageProgressJSON));
                            newProgress = newProgress.concat(storageProgressJSON);
                            //newProgress.push(...storageProgressJSON)
                            console.log('storageProgress1111==', storageProgress,id)
                            console.log('newProgress==', JSON.stringify(newProgress))
                        }
                        
                    } else {//如果没有，则读数据库加
                        if (progressJSON.length > 0) {
                            console.log('progressJSON', progressJSON)
                            newProgress = newProgress.concat(progressJSON);
                            //newProgress.push(...progressJSON)
                        }
                        
                    }
                    console.log('newProgress', newProgress,selectedNodes)
                    let type = res["data"]["catalogType"]
                    console.log('type==', type)
                    selectedNodes.forEach((node) => {
                        let collectionType = node.collectionType     
                        let nodeProgress = JSON.parse(node.progress)
                        // this.resetId(nodeProgress)
                        this.resetId(nodeProgress,'progress');
                        console.log("nodeProgress",node, node.progress,collectionType)
                        if ("answer_single" === collectionType) {
                            if (getModuleType(type,this)==2){//("题型专项训练" === type) {
                                console.log('题型专项训练 answer_single==', 11111)
                                if (newProgress.length === 0 ) {
                                    this.time++;
                                    newProgress.push({
                                      label: '',
                                      id: this.time + "",
                                      coilingId: id, //试卷id
                                      type: "题型专项训练", //听说模拟训练,题型专项训练
                                      progressItems: [],
                                    });
                                }
                            }else{  //四期情况，模块类型不属于题型专项和听说模拟
                              if (newProgress.length === 0 ) {
                                    this.time++;
                                    newProgress.push({
                                      label: '',
                                      id: this.time + "",
                                      coilingId: id, //试卷id
                                      type: "", //听说模拟训练,题型专项训练
                                      progressItems: [],
                                    });
                                }
                            }
                            console.log(newProgress);
                            newProgress[0].progressItems.push(nodeProgress);
                            console.log('题型专项训练 answer_single newProgress==', JSON.stringify(newProgress))
                        } else if ("answer_all" === collectionType) {
                            if (getModuleType(type,this)==2){//("题型专项训练" === type) {
                                console.log('题型专项训练 answer_all==', 222222)
                                console.log('题型专项训练 newProgress.length==', newProgress.length)
                                if (newProgress.length === 0 ) {
                                    this.time++;
                                    newProgress.push({
                                      label: '',
                                      id: this.time + "",
                                      coilingId: id, //试卷id
                                      type: "题型专项训练", //听说模拟训练,题型专项训练
                                      progressItems: [],
                                    });
                                }
                                let txNode0Progress = nodeProgress[0].progressItems
                                console.log('题型专项训练 txNode0Progress==', txNode0Progress)
                                newProgress[0].progressItems.push(...txNode0Progress)
                                //console.log('题型专项训练 nodeProgress==', nodeProgress)
                                console.log('题型专项训练 answer_all==', JSON.stringify(newProgress))
                            } else if (getModuleType(type,this)==1){//("听说模拟训练" === type) {
                                let minLen = Math.min(newProgress.length, nodeProgress.length)
                                console.log('minLen==', minLen,newProgress.length,nodeProgress.length)
                                for(let j=0; j < minLen; j++) {
                                    newProgress[j].progressItems.push(...nodeProgress[j].progressItems)
                                }
                            }else{  //四期情况，不同于听说模拟和题型专项训练
                              if (newProgress.length === 0 ) {
                                    this.time++;
                                    newProgress.push({
                                      label: '',
                                      id: this.time + "",
                                      coilingId: id, //试卷id
                                      type: "", //听说模拟训练,题型专项训练
                                      progressItems: [],
                                    });
                                }
                                let txNode0Progress = nodeProgress[0].progressItems
                                console.log('题型专项训练 txNode0Progress==', txNode0Progress)
                                newProgress[0].progressItems.push(...txNode0Progress)
                            }
                        }
                    })
                    if (id === this.$store.state.coilingId) {
                        if(newProgress.length > 0){
                            EventBus.$emit("updateProgressToPage", newProgress, type);
                        }
                    }
                    console.log('keytopList==', key+'topList')
                    console.log('newProgress', JSON.stringify(newProgress))
                    sessionStorage.setItem(key+'topList', JSON.stringify(newProgress));
                    EventBus.$emit('getProgressCollectionStatus', this.coilingId)

                    // EventBus.$emit('updateProgressShow', { 'newVal':contentJSON })  //四期新加，用于通知更新流程 notodo
                  } else {
                    fieldsArrChangeFn();
                  }
                })
                .catch(() => {
                  fieldsArrChangeFn();
                });
        });
    },
    resetId (json,type) {
      // if (json) {
      //     //需要重新获取，否则插入的id将与从页面插入的id重复而导致收藏错误      
      //     let newId = parseInt(new Date().getTime())
      //     if (Array.isArray(json)) {
      //         //答题流程改内部items的id
      //         if (type === 'progress') {
      //             json.forEach((item)=>{
      //                 item.progressItems.forEach((progressItem)=>{
      //                     newId++;
      //                     progressItem.id = newId + ""
      //                 })
      //             })
      //         } else {
      //             //试题内容改id,
      //             json.forEach((item)=>{
      //                 newId++;
      //                 item.id = newId + ""
      //             })
                  
      //         }
              
      //     } else {
      //         //单个的直接改id
      //         newId++;
      //         json.id = newId + "";             
      //     }
      //     //流程只需要改变items的id 
      // }
      if (json) {
          //需要重新获取，否则插入的id将与从页面插入的id重复而导致收藏错误
          let newId = parseInt(new Date().getTime())
          if (Array.isArray(json)) {
            if (type === 'progress') {
                json.forEach((item)=>{
                    item.progressItems.forEach((progressItem)=>{
                        newId++;
                        progressItem.id = newId + ""
                    })
                })
            } else {
              json.forEach((item)=>{
                  newId++;
                  item.id = newId + ""
              })
            }
          } else {
              newId++;
              json.id = newId + "";
          }
      }
    },
    refreshStorage(ids) {
      console.log(TAG + "刷新插入收藏的页面数据到缓存，ids为", ids);
      const fieldsArrChangeFn = () => {
        fieldsArrExternal = this.fieldsArr;
        this.$emit("fieldsArrChange", this.fieldsArr);
      };
      ids.forEach((id) => {
            getCoilingDetail(id)
              .then((res) => {
                console.log(TAG, "emptyFieldsArr getCoilingDetail res", res);
                if (res["code"] == 0) {
                  let content = res["data"]["content"]
                    ? res["data"]["content"]
                    : "[]";
                    console.log('content==', content)
                  let progress = res["data"]["top_list"]
                    ? res["data"]["top_list"]
                    : "[]";
                    console.log('progress==', progress)
                  let contentJSON = JSON.parse(content);
                  let key = id + "";               
                  sessionStorage.setItem(key, JSON.stringify(contentJSON));
                  sessionStorage.setItem(key+'topList', progress)
                  if (id === this.coilingId) {
                      this.fieldsArr = contentJSON;
                      fieldsArrChangeFn();
                      EventBus.$emit("contentChangeIdUn", this.coilingId);
                      this.$emit("update:enable", res["data"]["status"] == "0");
                  }

                  // EventBus.$emit('updateProgressShow', { 'newVal':contentJSON })  //四期新加，用于通知更新流程 notodo
                } else {
                  fieldsArrChangeFn();
                }
              })
              .catch(() => {
                fieldsArrChangeFn();
              });
      });
    
      
    },
    // 新增套卷-清空列表 ,重新加载内容
    refreshPageData(id) {
      console.log(TAG + "刷新当前页面数据，id为", id);
    
      //if (id == this.coilingId) return;
      if (id == -1) {
        this.fieldsArr = [];
        this.fieldsArrActive = [];
        this.fieldsArrOld = [];
        return;
      }
      this.coilingId = id;
      this.fieldCount = 1;
    
      this.fieldsArr = [];
      this.fieldsArrActive = [];
      this.fieldsArrOld = [];
    
      //let key = this.coilingId + "";
      //let ArrOld = sessionStorage.getItem(key);
    
      // 这里处理对象变化的逻辑
      const fieldsArrChangeFn = () => {
        fieldsArrExternal = this.fieldsArr;
        this.$emit("fieldsArrChange", this.fieldsArr);
      };
      
      
      getCoilingDetail(id)
        .then((res) => {
          console.log(TAG, "emptyFieldsArr getCoilingDetail res", res);
          if (res["code"] == 0) {
            this.publishState=res['data']["publish"]
            let content = res["data"]["content"]
              ? res["data"]["content"]
              : "[]";
              console.log('content==', content)
            let progress = res["data"]["top_list"]
              ? res["data"]["top_list"]
              : "[]";
              console.log('progress==', progress)
            // if (res["data"]["content"]) {
            /* if (ArrOld) {
              this.fieldsArrOld = JSON.parse(content);
              this.fieldsArr = JSON.parse(ArrOld);
            } else {
              this.fieldsArrOld = JSON.parse(content);
              this.fieldsArr = JSON.parse(content);
            } */
            this.fieldsArr = JSON.parse(content);
            // }
            console.log(TAG, "res[data][status] res", res["data"]["status"]);
    
            this.$emit("update:enable", res["data"]["status"] == "0");
    
            fieldsArrChangeFn();
            
            
            
            let key = this.coilingId + "";
            EventBus.$emit("contentChangeIdUn", this.coilingId);
            sessionStorage.setItem(key, JSON.stringify(this.fieldsArr));
            sessionStorage.setItem(key+'topList', progress)
            // EventBus.$emit('updateProgressShow', { 'newVal': this.fieldsArr })  //四期新加，用于通知更新流程 notodo
          } else {
            fieldsArrChangeFn();
          }
        })
        .catch(() => {
          fieldsArrChangeFn();
        });
    },
    // 新增套卷-清空列表 ,重新加载内容
    emptyFieldsArr(id) {
      console.log(TAG + "清空列表,重新加载内容");

      if (id == this.coilingId) return;
      if (id == -1) {
        this.fieldsArr = [];
        this.fieldsArrActive = [];
        this.fieldsArrOld = [];
        return;
      }
      this.coilingId = id;
      this.fieldCount = 1;

      this.fieldsArr = [];
      this.fieldsArrActive = [];
      this.fieldsArrOld = [];

      let key = this.coilingId + "";
      let ArrOld = sessionStorage.getItem(key);

      // 这里处理对象变化的逻辑
      const fieldsArrChangeFn = () => {
        fieldsArrExternal = this.fieldsArr;
        this.$emit("fieldsArrChange", this.fieldsArr);
      };
      
      
      getCoilingDetail(id)
        .then((res) => {
          console.log(TAG, "emptyFieldsArr getCoilingDetail res", res);
          if (res["code"] == 0) {
            this.publishState=res['data']["publish"]
            let content = res["data"]["content"]
              ? res["data"]["content"]
              : "[]";
            // if (res["data"]["content"]) {
            //原逻辑，没有考虑缓存为[]的情况
            // if (ArrOld) {
            //   this.fieldsArrOld = JSON.parse(content);
            //   this.fieldsArr = JSON.parse(ArrOld);
            // } else {
            //   this.fieldsArrOld = JSON.parse(content);
            //   this.fieldsArr = JSON.parse(content);
            // }
            // }
            if (ArrOld && ArrOld!='[]') {
              this.fieldsArrOld = JSON.parse(content);
              this.fieldsArr = JSON.parse(ArrOld);
            } else {
              this.fieldsArrOld = JSON.parse(content);
              this.fieldsArr = JSON.parse(content);
            }

            console.log(TAG, "res[data][status] res", res["data"]["status"]);

            this.$emit("update:enable", res["data"]["status"] == "0");

            fieldsArrChangeFn();
            
            // EventBus.$emit('updateProgressShow', { 'newVal':JSON.parse(content) })  //四期新加，用于通知更新流程 notodo
          } else {
            fieldsArrChangeFn();
          }
        })
        .catch(() => {
          fieldsArrChangeFn();
        });
    },
    //音频上传前校验
    beforeUploadAudio(file) {console.log(file);
      this.isLoading = true
      const isAudio = file.type === "audio/mp3" || file.type === "audio/mpeg";
      if (!isAudio) {
        this.isLoading = false
        this.$message.error("请上传音频文件!");
      } else {

        this.getTimes(file)
      }
      return isAudio
    },

    handleAudioSuccess(res) {
      this.showAudio(res)
    },
    //显示音频栏,新建的流程按此方式显示 拉取的数据需要另作判断
    showAudio(res) {
      this.fieldsArr.find((x) => x.id == this.nowId)["hearLink"] = res.data;

    },
    handleAudioError() {
      this.isLoading = false
      this.$message.error('上传失败,请检查网络并重新上传!')
    },
    //获取音频时长
    getTimes(file) {
      const content = file;
      const url = URL.createObjectURL(content);
      const audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", () => {
        //音频详情
        this.fieldsArr.find((x) => x.id == this.nowId)["hearTime"] = parseInt(audioElement.duration);
        this.fieldsArr.find((x) => x.id == this.nowId)["audioName"] = file.name;
      });
    },

    //转换成'00:00'分秒显示
    parseTime(scecond) {
      let secondTime = scecond
      let minuteTime = 0;
      if (scecond > 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
      }
      secondTime = secondTime < 10 ? "0" + secondTime : secondTime;
      let result = "" + secondTime + "";
      if (minuteTime > 0) {
        //若分钟数是个位数，前面用0补齐
        minuteTime = minuteTime < 10 ? "0" + minuteTime : minuteTime;
        result = "" + minuteTime + ":" + result;
      } else {
        //若分钟数为0，用"00"表示
        result = "" + "00" + ":" + result;
      }
      return result;
    },
  },

  watch: {
    fieldsArr: {
      handler: function (newUser) {
        let key = this.coilingId + "";
        if (newUser.length == 0) {
          sessionStorage.setItem(key, JSON.stringify(this.fieldsArr));
          return;
        }

        console.log(
          3334,
          this.coilingId,
          JSON.stringify(this.fieldsArr).substring(0, 100),
          JSON.stringify(this.fieldsArrOld).substring(0, 100)
        );
        

        let contentChange =
          JSON.stringify(this.fieldsArr) == JSON.stringify(this.fieldsArrOld);

        if (contentChange) {
          // 内容未变，移除sessionStorage
          sessionStorage.removeItem(key);
          // EventBus.$emit("contentChangeIdEnd", this.coilingId);  //左侧联动试卷按钮星号的代码  暂时注释  todo
        } else {
          // 内容改变，存到sessionStorage
          EventBus.$emit("contentChangeIdUn", this.coilingId);
          sessionStorage.setItem(key, JSON.stringify(this.fieldsArr));
        }
        this.fieldCount = Number(_.get(_.maxBy(newUser, function (o) { return Number(o.fieldId) }), 'fieldId', 1)) + 1;
        // fieldsArr存vuex
        this.fieldsJSONChange(newUser);
        EventBus.$emit("getCollectionStatus", this.coilingId); //notodo 查看收藏状态
      },
      deep: true, // 设置 deep 选项为 true，实现深度监听
    },
  },
};
</script>

<script setup>
import Sortable from "sortablejs";
import { ref, onMounted, nextTick } from "vue";

const sortableRef = ref(null);

function initSortable() {
  new Sortable(sortableRef.value, {
    delay: 10,
    animation: 150,
    // 如果有不想排序的，在这里按照class匹配的方式写出即可
    filter: ".demo-title",
    // 需要拖拽的标签的class，强烈推荐写
    draggable: ".fieldsList",
    handle: ".fieldsMove",
    // drop placeholder的css类名
    ghostClass: "blue-background-class",
    onEnd: (evt) => {
      // console.log(
      //   "initSortable",
      //   evt,
      //   fieldsArrExternal,
      //   addFieldThis.fieldsArr
      // );
      // let arrTemp = [].concat(fieldsArrExternal);

      let spliceObj = fieldsArrExternal.splice(evt.oldIndex, 1);
      fieldsArrExternal.splice(evt.newIndex, 0, spliceObj[0]);

      addFieldThis.fieldsArrActive = [];
      addFieldThis.fieldsArrActive[evt.newIndex] = true;

      addFieldThis.fieldsArr = fieldsArrExternal;

      addFieldThis.$emit("fieldsArrChange", fieldsArrExternal);
    },
  });
}

onMounted(() => {
  nextTick(() => {
    initSortable();
  });
});
</script>

<style lang="scss" scoped>
// @import "./AddFields.scss";
@import "./AddFields.css";

.fieldsList {
  :deep .el-upload {
    display: block;
  }
  :deep .el-upload:focus {
    color: #606266;
  }
}

.operateBox {
  width: 112rem;
  position: fixed;
  z-index: 2;
  background: #fff;
  border: 1rem solid rgba(0, 0, 0, 0.15);
  border-radius: 4rem;
}

/* 输入框的样式表 */
.no-scroll textarea {
  overflow: hidden;
  /* 禁用滚动条 */
  resize: none;
  /* 禁止用户手动调整文本框的尺寸 */
  height: auto !important;
  /* 强制将高度设置为自适应 */
  max-height: none !important;
  /* 禁用最大高度限制 */
}

:deep .no-scroll .el-textarea__inner {
  border: none;
  padding: 6rem 15rem 6rem 12rem;
  font-weight: inherit;
}

:deep .no-scroll .el-textarea__inner::-webkit-scrollbar {
  width: 13rem;
  /* 设置滚动条宽度 */
}

.idTextInput {
  width: 45rem;
  display: flex;
  align-items: center;

  :deep .el-input__inner {
    padding: 0 3rem !important;
    border: 1rem solid rgba(0, 0, 0, 0);
    font-size: 12rem;
  }

  :deep .el-input__inner:focus {
    border: 1rem solid #dcdfe6;
  }
}

.idTextInput1 {
  width: 50rem;
}

.uploadImgBorder {
  border-top: 1rem solid #e9e9e9;
}
</style>

<style lang="scss">
.fieldsOperation .el-input__inner {
  width: 100%;
  height: 100%;
  padding: 0 !important;
}

.fieldsOperation .el-input__suffix {
  display: none;
}

.fieldsOperation .el-cascader {
  opacity: 0;
}

.el-cascader-node {
  padding: 0 30rem 0 14rem !important;
}

.el-cascader-menu {
  min-width: 40rem !important;
}

.happy-scroll-container .happy-scroll-content {
  width: 100%;
}

.queSelect {
  display: flex;
  white-space: nowrap;
  flex-direction: row;
  align-items: center;
}
.idText{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.queSelect .el-select {
  width: 90rem;
  font-size: 12rem;
}
.queSelect .el-select .el-input--suffix{
  display: flex;
  align-items: center;
}
</style>

<style>
.errorDialog {
  border-radius: 8rem;
}
</style>